import Div100vh from "react-div-100vh"

const SplashComponent = () => {
  return <Div100vh className={'bg-brand dark:bg-dark flex justify-center items-center'}>
    <div className={'text-center flex flex-col justify-center items-center animate-bounce'}>
      <img alt="همراه بورس" src={require('./../../assets/img/logo-light.svg').default} className={'h-7 mb-3'}/>
    </div>
  </Div100vh>
}
export default SplashComponent;